import ScrollReveal  from 'scrollreveal'
import BlogToc from './components/BlogToc'

let components = {
  BlogToc,
}

class OnLoad {
  run() {
    this.setWindowGlobals() 
    this.runOnDOM()
    this.runOnLoad()
  }

  runOnDOM() {
    // just DOM loaded (not all resources)
    document.addEventListener('DOMContentLoaded', () => {
      this.setIcons()
      this.initReveal()
      this.initReactAssets()
    })
  }

  runOnLoad() {
    // all resources have loaded
    window.addEventListener('load', () => {
    })
  }

  setWindowGlobals() {
    window.app.components = {...window.app.components, ...components}
  }
  
  setIcons() {
    document.querySelectorAll('[data-bullet-icon]').forEach(
      el => {
        el.classList.add('has_bullet')
        el.style.backgroundImage = `url(${el.dataset.bulletIcon})`
      }
    )
  }

  initReveal() {
    const classes_to_reveal = ['.liner', '.highlight']

    classes_to_reveal.forEach(
      klass => ScrollReveal().reveal(klass, 
        // options: https://scrollrevealjs.org/api/defaults.html
        { 
          // delay: 100,
          duration: 1700,
          reset: true,
        } 
      ) 
    )
  }

  initReactAssets() {
  }
}

export default new OnLoad















